// Where the floating AI button sits (src/components/FloatingAssistant.jsx). It can be dragged; the spot is kept in this
// browser (localStorage, one for phone width and one for wider screens) and always clamped back on screen: never under
// the phone tab bar or the phone header, never off an edge after a resize. Distances are from the right / bottom edge
// (on a phone the CSS adds the home-bar safe area to the bottom).
export const FAB_SIZE = 54
export const FAB_MARGIN = 8
export const TABBAR_H = 58     // .hc-tabbar in AppShell.jsx (phone)
export const HEADER_H = 52     // .hc-header on a phone
export const FAB_KEY = 'hc_fab_pos'
export const defaultFabPos = narrow => ({ right: 18, bottom: narrow ? TABBAR_H + 16 : 22 })

export function clampFab(pos, vw, vh, narrow) {
  const p = pos && Number.isFinite(pos.right) && Number.isFinite(pos.bottom) ? pos : defaultFabPos(narrow)
  const minB = narrow ? TABBAR_H + FAB_MARGIN : FAB_MARGIN
  const maxB = Math.max(minB, vh - FAB_SIZE - (narrow ? HEADER_H : 0) - FAB_MARGIN)
  const maxR = Math.max(FAB_MARGIN, vw - FAB_SIZE - FAB_MARGIN)
  const c = (v, lo, hi) => Math.round(Math.min(hi, Math.max(lo, v)))
  return { right: c(p.right, FAB_MARGIN, maxR), bottom: c(p.bottom, minB, maxB) }
}

const slot = narrow => (narrow ? 'narrow' : 'wide')
export function loadFabPos(narrow, storage = globalThis.localStorage) {
  try { const all = JSON.parse(storage.getItem(FAB_KEY) || '{}'); return all[slot(narrow)] || defaultFabPos(narrow) } catch (e) { return defaultFabPos(narrow) }
}
export function saveFabPos(narrow, pos, storage = globalThis.localStorage) {
  try { const all = JSON.parse(storage.getItem(FAB_KEY) || '{}'); all[slot(narrow)] = { right: pos.right, bottom: pos.bottom }; storage.setItem(FAB_KEY, JSON.stringify(all)) } catch (e) {}
}
